import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const ContractAPI = {
	listByPlayer: async (playerId) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayersContracts/player/" + playerId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayersContracts/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/PlayersContracts",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/PlayersContracts/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/PlayersContracts/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	expiring: async (days = 90) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayersContracts/expiring",
			params: {days},
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
};
